// Businesses for which the Mepco (Talenom) salary transfer CSV must include the
// assignment (Littera) number + name in the last column of the work-salary rows.
// Gated by business id so other Mepco customers' output is unaffected.
export const MEPCO_LITTERA_BUSINESS_IDS = ['0909014-5', '9999999-9', '1234'];

export const isMepcoLitteraBusiness = (businessId) =>
  !!businessId && MEPCO_LITTERA_BUSINESS_IDS.includes(businessId);
